var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDibetology(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.6851 18.0887C26.6859 19.0887 25.867 19.8751 24.824 19.876C23.781 19.8769 22.9608 19.0918 22.96 18.0918C22.9592 17.0918 24.8199 14.876 24.8199 14.876C24.8199 14.876 26.6843 17.1602 26.6851 18.0887Z",
    fill: "#2EAD9F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9781 10.9991L25.979 10.99C26.7087 10.9894 27.3007 11.5844 27.3013 12.319C27.3019 13.0535 26.7109 13.6495 25.9812 13.6501H25.978C26.0313 13.5454 26.0605 13.4318 26.0604 13.3129C26.06 12.7951 25.5037 12.3759 24.818 12.3765C24.1322 12.377 23.5766 12.7972 23.577 13.3149C23.5771 13.4338 23.6065 13.5475 23.66 13.652L15.5752 13.6587L15.5758 14.3237L19.8528 14.3202C20.5385 14.3196 21.0949 14.8788 21.0955 15.5691L21.0956 15.7293C21.0961 16.4196 20.5407 16.9797 19.8549 16.9803L15.578 16.9838L15.5785 17.6488L19.1656 17.6459C19.8514 17.6453 20.4077 18.2045 20.4083 18.8948L20.4085 19.055C20.409 19.7453 19.8536 20.3054 19.1678 20.306L14.201 20.3101L14.2015 20.9751L16.7539 20.973C17.4397 20.9724 17.9961 21.5316 17.9966 22.222L17.9967 22.3821C17.9973 23.0724 17.4418 23.6325 16.7561 23.6331L12.1342 23.6369L9.58913 23.639C5.66094 23.6422 2.47393 20.4391 2.47071 16.4847C2.46834 13.5756 4.21465 10.9543 6.88912 9.85232L14.8873 6.55683C15.4918 6.30776 16.1871 6.5017 16.578 7.02845C17.1246 7.76476 16.8567 8.82101 16.0264 9.20351L14.7193 9.80576C14.1126 10.0852 14.311 10.9996 14.9781 10.9991Z",
    fill: "#2EAD9F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDibetology);
export default __webpack_public_path__ + "static/media/dibetology.604995a606d57c80031bbb9f19dfabc4.svg";
export { ForwardRef as ReactComponent };